<template>
  <div style="text-align: center;">
    <h5>管理员日志</h5>
    <el-table :data="students" style="width: 100%">
      <el-table-column prop="id" label="ID" width="180"></el-table-column>
      <el-table-column prop="username" label="姓名" width="180"></el-table-column>
      <el-table-column prop="information" label="事件"></el-table-column>
      <el-table-column prop="user_ip" label="ip地址"></el-table-column>
      <el-table-column prop="datetime" label="查询时间"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'; // 确认路径是否正确
import { ElMessage } from 'element-plus';

export default {
  data() {
    return {
      students: []
    };
  },
  mounted() {
    this.fetchStudents();
  },
  methods: {
    async fetchStudents() {
      try {
        const response = await axios.get('/getadminlog');
        this.students = response.data;
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '获取管理员日志失败',
        });
        // console.error("获取管理员日志失败:", error);
      }
    }
  }
};
</script>
